import { ref, type Ref } from "vue";
import { storeToRefs } from "pinia";
import { useAccountStore } from "@/shared/stores";
import {
  type GasContainer,
  mapToGasContainerType,
} from "@/app/fbs-hub-app/shared/@types";
import { getContainers } from "../services";

export const useGetGasContainers = () => {
  const accountStore = useAccountStore();
  const { user, selectedCustomer } = storeToRefs(accountStore);

  const gasContainers = ref<GasContainer[]>([]);
  const fetchingGasContainersError: Ref<string | undefined> = ref(undefined);
  const isFetchingGasContainers = ref(false);

  const onFetchingGasContainers = async () => {
    if (!user.value || !selectedCustomer.value?.id) return;

    try {
      fetchingGasContainersError.value = undefined;
      isFetchingGasContainers.value = true;

      const containers = await getContainers({
        userId: user.value.userId,
        customerId: selectedCustomer.value.id,
      });
      gasContainers.value = containers.map((container, index) =>
        mapToGasContainerType(container, index),
      );
    } catch (error) {
      fetchingGasContainersError.value = error as string;
    } finally {
      isFetchingGasContainers.value = false;
    }
  };
  return {
    gasContainers,
    fetchingGasContainersError,
    isFetchingGasContainers,
    onFetchingGasContainers,
  };
};
